module.exports = __webpack_public_path__ + "img/speed-start-image-computers.7d465c8a.png";